import type { ElementType } from 'react'
import { styled } from '@mui/material/styles'
import { StyledButton } from './StyledButton'
import type { ButtonProps } from '@mui/material'

export type ToolbarButtonProps = ButtonProps & {
    component?: ElementType
    to?: string
    dense?: boolean
    modalized?: boolean
}

export const ToolbarButton = styled(StyledButton, {
    shouldForwardProp: (prop) =>
        prop !== 'dense' && prop !== 'modalized' && prop !== 'sx',
})<ToolbarButtonProps>(({ dense }) => {
    return {
        height: dense ? 32 : 42,
        minWidth: dense ? 32 : 42,

        '& .MuiButton-endIcon > svg': {
            fontSize: dense ? '0.875rem' : undefined,
        },

        '& .MuiButton-startIcon > svg': {
            fontSize: dense ? '0.875rem' : undefined,
        },
    }
})
